import EAButton from 'components/common/EAButton';
import EAIcon from 'components/common/EAIcon';
import EAPopper from 'components/common/EAPopper';
import i18next from 'i18next';
import { useRef, useState } from 'react';
import { getCountryName } from 'services/common/EcovadisUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';

const EAScopeChangeDetail = ({ evData }) => {
  const { classes } = useStyles();
  return (
    <div className={classes.scopeChangeDetailWrapper}>
      <div>{i18next.t('ecovadis.scopeChangeDetail')}</div>
      <div className={classes.scopeChangesBloc}>
        <div className={classes.scopeChangeItem}>
          <div>{i18next.t('company')} : </div>
          <div className={classes.scopeChangeValue}>
            <span>
              {evData?.ev_supplier_name || evData?.client_supplier_name}
            </span>
            <EAIcon icon="arrow/arrow-to-right_large" />
            <span>{evData?.target_company_name}</span>
          </div>
        </div>
        <div className={classes.scopeChangeItem}>
          <div>{i18next.t('country')} : </div>
          <div className={classes.scopeChangeValue}>
            <span>{getCountryName(evData?.country)}</span>
            <EAIcon icon="arrow/arrow-to-right_large" />
            <span>{getCountryName(evData?.target_company_country)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const EcovadisScopeChangePopper = ({ evData, buttonStyle = {} }) => {
  const { classes } = useStyles();
  const [isPopperOpen, setIsPopperOpen] = useState(false);
  const anchorRef = useRef(null);
  return (
    <>
      <div
        ref={anchorRef}
        className={classes.scopeChangeButton}
        style={{ ...buttonStyle }}
      >
        <EAButton
          size="xs"
          onClick={() => setIsPopperOpen((prev) => !prev)}
          colorVariant="warningLight"
          customStyle={{ minWidth: 0 }}
          content={
            <>
              <EAIcon icon="warning-snack" />
            </>
          }
        />
      </div>
      {isPopperOpen && (
        <EAPopper
          open={isPopperOpen}
          anchorEl={anchorRef.current}
          placement="top-end"
          onClose={() => setIsPopperOpen(false)}
          title={i18next.t('ecovadis.scopeChange')}
          titleVariant="warning"
        >
          <EAScopeChangeDetail evData={evData} />
        </EAPopper>
      )}
    </>
  );
};

export default EcovadisScopeChangePopper;
